import { CAMERA_GRAPH_DIAGNOSTICS } from './_data/cameraGraphDiagnostics.js';
import { validateCameraGraph } from './_pure/cameraGraph.js';
import { projectCameraGraphDiagnosticsFrame } from './_pure/cameraGraphDiagnostics.js';
import { resolveCameraViewPose } from './_pure/cameraStation.js';
/** Owned by the enabled-only component, never shared with navigation's station state. */
export function createCameraGraphDiagnosticsProjection() {
    const stations = new Map();
    return {
        get cachedStationCount() { return stations.size; },
        clear() { stations.clear(); },
        project(frame, playback, pose, aspect) {
            const camera = playback.spaceRenderOptions?.camera;
            const graph = camera?.graph;
            if (!graph) {
                stations.clear();
                return frame;
            }
            validateCameraGraph(graph);
            for (const id of stations.keys())
                if (!Object.hasOwn(graph.stations, id))
                    stations.delete(id);
            const positions = new Map();
            for (const [id, station] of Object.entries(graph.stations)) {
                const state = stations.get(id) ?? {};
                // Navigation retains an arrived station's FOV; diagnostics follow the actual live FOV.
                if (station.fov === undefined && state.current?.fov !== pose.fov)
                    delete state.current;
                const view = Object.values(graph.views).find((entry) => entry.station === id)
                    ?? { station: id, target: { anchorKind: 'origin' } };
                positions.set(id, resolveCameraViewPose(playback, view, pose, aspect, state).position);
                stations.delete(id);
                stations.set(id, state);
                if (stations.size > CAMERA_GRAPH_DIAGNOSTICS.cacheLimit)
                    stations.delete(stations.keys().next().value);
            }
            return projectCameraGraphDiagnosticsFrame(frame, graph, camera?.activeView, positions);
        },
    };
}
